// Like the existing sponsor/entry messages, secondary locales fall back to English.
export const emailLinkMessages = {
  en: {
    attach: 'Link email',
    verify: 'Verify email',
    siteAccess: 'Link your email to sign in to the same Gonka Game account on the website.',
    verifyAccess: 'Verify {email} to sign in to this account on the website. You can also correct the address.',
    later: 'Later',
    occupied: 'This email is already used by another Gonka Game account. Enter a different email.',
    telegramLogin: 'Already started in the bot or Mini App? Sign in with Telegram to keep the same account.',
  },
  ru: {
    attach: 'Привяжите email',
    verify: 'Подтвердите email',
    siteAccess: 'Привяжите почту, чтобы входить в тот же аккаунт Gonka Game на сайте.',
    verifyAccess: 'Подтвердите {email}, чтобы входить в этот аккаунт на сайте. Если в адресе ошибка, его можно исправить.',
    later: 'Позже',
    occupied: 'Этот email уже используется в другом аккаунте Gonka Game. Введите другой адрес.',
    telegramLogin: 'Уже начали в боте или Mini App? Войдите через Telegram, чтобы продолжить в том же аккаунте.',
  },
}
